import styled from 'styled-components/macro';

import { chatUI } from 'styles/featureColors/chatUIColors';
import { ActionButton } from '../ChatUI.styles';

/** *** Recommended Macros Bar *****/

export const ButtonContainer = styled.div`
  display: flex;
  position: relative;
  justify-content: flex-start;
  align-items: center;

  height: 25px;
  padding-left: 16px;
  overflow: visible;
  border-bottom: 1px solid ${chatUI.content.border};

  animation-name: fadeIn;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;

  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }
`;

export const RecommendationButton = styled.button`
  max-width: 125px;
  height: 100%;
  background-color: ${chatUI.content.background};
  color: ${(props) =>
    props.selected ? chatUI.content.macros.title.selectedText : chatUI.content.macros.title.regularText};
  border: 0px;
  border-bottom: ${(props) =>
    props.selected ? `1px solid ${chatUI.content.macros.title.selectedText}` : `1px solid transparent`};
  padding-top: 1px;
  padding-bottom: 0px;
  margin-right: 20px;

  font: normal 400 10px/17px Roboto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  outline: none;
  transition: 0.3s;
  position: relative;

  &:last-child {
    margin-right: 0px;
  }
`;

/** *** Rcommended Macro Content *****/

export const MacroMetadataWrapper = styled.div`
  padding: 10px 0 0 20px;
`;

export const RecommendationContainer = styled.div`
  height: 75px;
  padding: 0px;
  z-index: 0;
  display: flex;
  flex-direction: row;

  textarea {
    flex-grow: 1;
    display: flex;
    align-items: center;
    font: normal 300 10px/16px Roboto;
    background-color: ${chatUI.content.background};
    color: ${chatUI.content.macros.body};
    overflow-y: auto;
    border: none;
    resize: none;
    outline: none;
    overflow: hidden;
    overflow-y: scroll;
    width: 100%;
    padding: 5px 5px 5px 0;
  }

  animation-name: fadeIn;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;

  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }
`;

export const LeftSideContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 120px);
  overflow: hidden;
  padding: 0px;
`;

/** *** Recommended Macro Buttons *****/

export const RightSideContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 120px;
  padding: 10px 20px 13px 20px;
`;

export const NotHelpfulButton = styled(ActionButton)`
  background-color: ${chatUI.buttons.default};
  border: 1px solid ${chatUI.content.border};
  color: ${chatUI.buttons.textDark};
`;

export const UseThisButton = styled(ActionButton)`
  background-color: ${chatUI.buttons.useThis};
  border: 1px solid ${chatUI.content.border};
  color: ${chatUI.buttons.textLight};
  margin-top: 5px;
`;
